var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormContainer, CenteredContainer } from '../../../../styles/generalStyles';
import { TitleForm, MainTextStyle, } from '../../../../styles/variables/text.styles';
import { Button } from '../../../_common/button/button.styles';
import LangMessage from '../../../_common/lang/message';
var SuccessSendEmail = function (_a) {
    var handleFormChangeAnimate = _a.handleFormChangeAnimate;
    return (_jsx(FormContainer, __assign({ style: { justifyContent: 'center' } }, { children: _jsxs(CenteredContainer, { children: [_jsx(TitleForm, __assign({ width: '60%' }, { children: _jsx(LangMessage, { msgKey: 'form.successScreenAfterSendEmail' }) })), _jsx(MainTextStyle, __assign({ width: '60%', "$paddingBottom": '40px', "$paddingTop": '15px' }, { children: _jsx(LangMessage, { msgKey: 'form.successScreenAfterSendCheckEmail' }) })), _jsx(Button, __assign({ "$bgColour": 'blue', "$size": 'big', onClick: function () { return handleFormChangeAnimate && handleFormChangeAnimate('login'); } }, { children: _jsx(LangMessage, { msgKey: 'form.backToLogin' }) }))] }) })));
};
export default SuccessSendEmail;
